import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
    apiKey: "AIzaSyCsLiMsEAhV36kuayhsMZq-TtRZ1Ak1BUk",
    authDomain: "bunchy-73e2f.firebaseapp.com",
    projectId: "bunchy-73e2f",
    storageBucket: "bunchy-73e2f.firebasestorage.app",
    messagingSenderId: "515897024810",
    appId: "1:515897024810:web:484b1224bf8c2e9e4e7e53",
    measurementId: "G-HWNB13E49R"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
const functions = getFunctions(app);

const googleMapsApiKey = "AIzaSyC6krbV8kMp2zDMD63kDOehOABwEMRGbvw";

export { app, auth, db, storage, functions, googleMapsApiKey };
